import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-stacked-card',
  templateUrl: './stacked-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackedCardComponent {
  @Input() interactive = false;
  @Input() cardLabel = '';
  @Output() cardClick = new EventEmitter<void>();

  /**
   * @description Activates an interactive card. Bound to click and to enter/space so the card is operable by keyboard
   * @returns {void} void
   */
  onActivate(): void {
    if (this.interactive) {
      this.cardClick.emit();
    }
  }
}
